let url = {};
switch (process.env.NODE_ENV) {
  case 'development':
    url = {
      base: 'https://dev-a-gateway.epec.com/api',
      // base: "https://dev-gateway.epec.com/api",
      oldService: 'https://uat-member.epec.com',
      easySeries: 'https://uat-mall.epec.com',
    };
    break;
  case 'fix':
    url = {
      base: 'https://uat-gateway.epec.com/api',
      oldService: 'https://uat-member.epec.com',
      easySeries: 'https://uat-mall.epec.com',
    };
    break;
  case 'uat':
    url = {
      base: 'https://uat-gateway.epec.com/api',
      oldService: 'https://uat-member.epec.com',
      easySeries: 'https://uat-mall.epec.com',
    };
    break;
  case 'production':
    url = {
      base: 'https://gateway.epec.com/api',
      oldService: 'https://member.epec.com',
      easySeries: 'https://mall.epec.com',
    };
    break;
}
let baseOssUrl = '';
switch (process.env.NODE_ENV) {
  case 'development':
    baseOssUrl = 'http://uat-static.epec.com/';
    break;
  case 'fix':
    baseOssUrl = 'https://uat-static.epec.com/';
    break;
  case 'uat':
    baseOssUrl = 'https://uat-static.epec.com/';
    break;
  case 'production':
    baseOssUrl = 'https://static.epec.com/';
    break;
  case 'pre':
    baseOssUrl = 'https://static.epec.com/';
    break;
}

let mallBaseUrl = '';
switch (process.env.NODE_ENV) {
  case 'development':
    mallBaseUrl = 'http://uat-vip.epec.com:3002';
    break;
  case 'fix':
    mallBaseUrl = 'https://bugfix-vip.epec.com';
    break;
  case 'uat':
    mallBaseUrl = 'https://uat-vip.epec.com';
    break;
  case 'pre':
    mallBaseUrl = 'https://pre-emall.epec.com/';
    break;
  case 'production':
    mallBaseUrl = 'https://vip.epec.com';
    break;
}

// 投标系统
let bidSysBaseUrl = '';
switch (process.env.NODE_ENV) {
  case 'development':
    bidSysBaseUrl = 'http://uat-bid.epec.com:3002/projectA/#/';
    break;
  case 'uat':
    bidSysBaseUrl = 'https://uat-bid.epec.com';
    break;
  case 'pre':
    bidSysBaseUrl = 'https://bid.epec.com';
    break;
  case 'production':
    bidSysBaseUrl = 'https://bid.epec.com';
    break;
}

// 投标系统
let callBackUrl = '';
switch (process.env.NODE_ENV) {
  case 'development':
    callBackUrl = 'http://uat-vip.epec.com:3002';
    break;
  case 'fix':
    callBackUrl = 'https://bugfix-vip.epec.com';
    break;
  case 'uat':
    callBackUrl = 'https://uat-vip.epec.com';
    break;
  case 'pre':
    callBackUrl = 'https://pre-vip.epec.com';
    break;
  case 'production':
    callBackUrl = 'https://vip.epec.com';
    break;
}

export const vipBaseUrl =
  process.env.NODE_ENV === 'production'
    ? 'https://vip.epec.com'
    : process.env.environment === 'pre'
      ? 'https://pre-vip.epec.com'
      : process.env.environment === 'uat'
        ? 'https://uat-vip.epec.com'
        : process.env.environment === 'fix'
          ? 'https://bugfix-vip.epec.com'
          : 'http://uat-vip.epec.com';

//  专属商城首页 | 易派客首页 | 运营后台 | 易学院
const customCategoriesList = [
  {
    name: '专属商城首页',
    url: `${vipBaseUrl}`,
    type: 1, //  1 内部导航 2 外部链接
    jumpType: '_self',
  },
  {
    name: '常采物资',
    url: `${mallBaseUrl}/purchaseRecord`,
    type: 1, //  1 内部导航 2 外部链接
    jumpType: '_self',
  },
  {
    name: '易派客在线商城',
    url: `${mallBaseUrl}`,
    type: 2, //  1 内部导航 2 外部链接
    jumpType: '_blank',
  },
  {
    name: '易学院',
    url: `${mallBaseUrl}/eCourse`,
    type: 2, //  1 内部导航 2 外部链接
    jumpType: '_blank',
  },
  {
    name: '供应资源',
    url: `${mallBaseUrl}/procurementZone/procurementZoneSearch?from=supplier`,
    type: 1, //  1 内部导航 2 外部链接
    jumpType: '_blank',
  },
  {
    name: '我要招标',
    url: `${mallBaseUrl}/activity/bidding`,
    type: 1, //  1 内部导航 2 外部链接
    jumpType: '_blank',
  },
];

// 在线商城 (老系统)
const oldMallBaseUrl =
  process.env.NODE_ENV === 'production'
    ? 'https://mall.epec.com'
    : process.env.NODE_ENV === 'uat'
      ? 'https://uat-mall.epec.com'
      : 'https://uat-mall.epec.com';

export {
  url,
  baseOssUrl,
  mallBaseUrl,
  bidSysBaseUrl,
  callBackUrl,
  customCategoriesList,
  oldMallBaseUrl,
};
